import type { ImageStyle } from 'react-native'

export const cardImageStyle = {
  height: 220,
  width: 350,
  borderRadius: 16,
  justifyContent: 'center',
} as const satisfies ImageStyle
